// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__G-I57","rootCenter":"LoadMoreObserver_rootCenter__2HHWp","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3w54u"};